module.exports = __webpack_public_path__ + "media/applicants/iphone@2x-e04d3e4a.png";